import axios from "axios";
import { API_URL } from "./baseUrl";

/**
 * Send email OTP after password auth when SMS phone is missing.
 * Requires login_challenge_token from auth/login.
 */
export const sendEmailOTPFor2fa = async (email, loginChallengeToken) => {
  try {
    const emailNorm = String(email || "").trim();
    const token = String(loginChallengeToken || "").trim();

    if (!emailNorm) {
      return { success: false, message: "Email is required" };
    }
    if (!token) {
      return {
        success: false,
        message: "Login challenge expired. Please sign in again.",
      };
    }

    const response = await axios.post(
      `${API_URL}auth/send-email-otp-for-2fa`,
      {
        email: emailNorm,
        login_challenge_token: token,
      },
      { withCredentials: true },
    );

    if (response.status === 200 && response.data.status === 1) {
      return {
        success: true,
        message: response.data.message || "OTP sent to your email",
        data: response.data.data,
      };
    }

    return {
      success: false,
      message: response.data.message || "Failed to send email OTP",
    };
  } catch (error) {
    console.error("Error sending email OTP:", error);
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to send email OTP. Please try again.",
    };
  }
};

/**
 * Verify email OTP from login.
 * @param {string} otp
 * @param {string} email
 * @param {Object} [options]
 * @param {boolean} [options.rememberBrowser]
 * @param {string} [options.deviceId]
 * @param {number} [options.trustedDays]
 */
export const verifyEmailOTP = async (otp, email, options = {}) => {
  try {
    if (!email) {
      return { success: false, message: "Email is required" };
    }
    if (!otp || String(otp).length < 6) {
      return { success: false, message: "Please enter the complete OTP" };
    }

    const payload = {
      otp: String(otp).trim(),
      email: String(email).trim(),
    };

    if (options.rememberBrowser) {
      payload.remember_browser = true;
      payload.device_id = options.deviceId || null;
      payload.trusted_days = options.trustedDays || 7;
    } else if (options.deviceId) {
      payload.device_id = options.deviceId;
    }

    const response = await axios.post(`${API_URL}auth/verifyOtp`, payload, {
      withCredentials: true,
    });

    if (response.status === 200 && response.data.status === 1) {
      const data = response.data.data?.[0] || response.data.data || {};
      return {
        success: true,
        message: response.data.message || "OTP verified successfully",
        user: data,
        trustedDeviceToken:
          data.trusted_device_token ||
          response.data.trusted_device_token ||
          null,
        trustedDeviceExpiresAt:
          data.trusted_device_expires_at ||
          response.data.trusted_device_expires_at ||
          null,
        deviceId:
          data.device_id || response.data.device_id || options.deviceId || null,
      };
    }

    return {
      success: false,
      message: response.data.message || "Invalid OTP",
    };
  } catch (error) {
    console.error("Error verifying email OTP:", error);
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Failed to verify OTP. Please try again.",
    };
  }
};
